import React from "react";
import { ContractJobType, ContractStatus } from "constants/enums";
import { ClearLabel } from "components/controls";
import { FieldNames } from "./ContractsFilters";

const FieldMappings = {
  [FieldNames.Status]: "Status",
  [FieldNames.JobTypes]: "Job Types",
  [FieldNames.ContractManagerDisplay]: "Contract Manager",
};

const FormatDisplay = (item) => {
  let value = item.value;
  switch (item.label) {
    case FieldNames.Status:
      value = item.value.map((x) => ContractStatus[x]).join(", ");
      break;
    case FieldNames.JobTypes:
      value = item.value.map((x) => ContractJobType[x]).join(", ");
      break;
  }

  return `${FieldMappings[item.label] || item.label}: ${value}`;
};

const ContractsFilterDisplay = ({ filters, resetFilters }) => {
  const items = filters
    ? Object.keys(filters)
        .filter(
          (f) => f !== FieldNames.Search && f !== FieldNames.ContractManager
        )
        .map((k) => {
          return {
            label: k,
            value: filters[k],
          };
        })
    : [];

  if (!items.length) return null;

  return (
    <div className="filter-display">
      {items
        .filter((i) => i.value != null && i.value != "")
        .map((item) => (
          <div
            className="filter-display-item"
            key={item.label}
            title={FormatDisplay(item)}
          >
            {FormatDisplay(item)}
          </div>
        ))}
      <ClearLabel onClick={resetFilters} />
    </div>
  );
};

export default ContractsFilterDisplay;
